import { AfterViewInit, Component, ElementRef, ViewChild, inject, NgZone, OnDestroy, effect } from '@angular/core';
import { EventService } from '../../services/event.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PresaleDataService } from '../../services/connection-services/data.service';

@Component({
  selector: 'app-exit-intent',
  standalone: false,
  templateUrl: './exit-intent.component.html',
  styleUrl: './exit-intent.component.scss',
})
export class ExitIntentComponent {
  @ViewChild('modalContour', { static: false })
  modalContour!: ElementRef;
  public readonly eventService = inject(EventService);
  public readonly liveCounter = this.eventService.daysCounter;
  private readonly dataService = inject(PresaleDataService);
  heading: string = 'PRESALE';
  salePrice: number = 0;
  targetListing: number = 0;
  nextEndDate: number | null = null;
  modalOrb!: ElementRef;
  constructor(public bsModalRef: BsModalRef) {
    effect(() => {
      this.dataService.widgetBalanceData();
      const step = this.dataService.balanceDataEVM?.currentStep ?? 0;
      const len = this.dataService.tokenomics?.length ?? 0;
      let nextStore: any = null;
      if (step + 1 < len) {
        nextStore = this.dataService.tokenomics?.[step + 1];
        this.nextEndDate = nextStore?.endDate ?? null;
      } else {
        this.nextEndDate = null;
      }
      const phaseNumber = step + 1;
      const currentStore = this.dataService.tokenomics?.[step];
      this.salePrice = currentStore?.tokenUSDT ?? 0;
      this.targetListing = nextStore?.tokenUSDT ?? currentStore?.tokenUSDT ?? 0;
      if (this.nextEndDate) {
        this.heading = `PRESALE PHASE ${phaseNumber} Ending Soon`;
      } else if (len > 0) {
        this.heading = `PRESALE PHASE ${phaseNumber} LIVE`;
      } else {
        this.heading = `PRESALE PHASE ${phaseNumber}`;
      }
    });
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }

  onBuyClick(): void {
    this.closeModal();
    this.dataService.connectWallet();
  }


}
